import script from "./AutoCompleteInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./AutoCompleteInput.vue?vue&type=script&lang=ts&setup=true"

import "./AutoCompleteInput.vue?vue&type=style&index=0&id=da200fc2&lang=scss"

const __exports__ = script;

export default __exports__